import BarChart from './BarChart';
import { ArrowUpRight, Users } from 'lucide-react';

export default function EarningsPanel({ monthly }) {
  return (
    <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
      <div className="p-4 bg-white rounded-xl border border-gray-200 shadow-sm lg:col-span-2">
        <div className="flex justify-between items-center mb-2">
          <h3 className="text-sm font-semibold">Monthly Earnings</h3>
          <select className="px-2 py-1 text-xs bg-white rounded-md border">
            <option>2023</option>
            <option>2024</option>
          </select>
        </div>
        <BarChart data={monthly} />
      </div>
      <div className="grid grid-rows-2 gap-6">
        <div className="p-4 bg-white rounded-xl border border-gray-200 shadow-sm">
          <p className="text-xs text-gray-500">Pending Earnings this month</p>
          <div className="mt-1 text-3xl font-bold">₵0.00</div>
          <div className="inline-flex gap-1 items-center mt-2 text-xs text-emerald-600"><ArrowUpRight size={14} /> 0% vs previous month</div>
        </div>
        <div className="flex gap-3 p-4 bg-white rounded-xl border border-gray-200 shadow-sm">
          <div className="flex justify-center items-center w-12 h-12 text-emerald-600 bg-emerald-50 rounded-full"><Users size={18} /></div>
          <div>
            <h4 className="text-sm font-semibold">Earn when you register a client</h4>
            <p className="text-xs text-gray-600">Boost your income with referral bonuses for every successful signup.</p>
            <button className="mt-2 px-3 py-1.5 text-xs font-medium text-white bg-emerald-600 rounded-lg hover:bg-emerald-700">Refer now</button>
          </div>
        </div>
      </div>
    </div>
  );
}


